import React from "react";
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import "./home.scss";

function Home() {
  const { t } = useTranslation();

  const textVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
  };

  const containerVariant = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.2 } }
  };

  return (
    <motion.div
      className="Home"
      initial="hidden"
      animate="visible"
      variants={containerVariant}
    >
      <div id="home-content">
        <div className="container">
          <motion.div className="home-text" variants={textVariant}>
            <motion.h1 variants={textVariant}>
              {t('homeGreeting')} <span>{t('homeIam')}</span> {t('Mehdi AKAMI')}
            </motion.h1>
            <motion.p variants={textVariant}>{t('homeTitle')}</motion.p>
            <motion.p variants={textVariant}>{t('homeWelcome')}</motion.p>
            <motion.p variants={textVariant}>{t('homeIntroPart1')}</motion.p>
            <motion.p variants={textVariant}>{t('homeIntroPart2')}</motion.p>
            <motion.p variants={textVariant}>{t('homeIntroPart3')}</motion.p>
            <motion.p variants={textVariant}>{t('homeIntroPart4')}</motion.p>
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
}

export default Home;
